import {
  Required,
  IsString,
  IsBoolean,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from './api'

// 原始接口
interface EmailLoginSessionResponse {
  email_session_id: string;
  first_login: boolean;
}

// 主数据类
export class EmailLoginSessionData {
  @Required("Email session ID cannot be empty")
  @IsString("Email session ID must be a string")
  emailSessionId: string;

  @Required("First login cannot be empty")
  @IsBoolean("First login must be a boolean")
  firstLogin: boolean;
}

const transformAndValidateEmailLoginSession = (
  response: EmailLoginSessionResponse
): EmailLoginSessionData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, EmailLoginSessionData);
  } catch (error) {
    console.error("Email login session data validation failed:", error.message);
    throw error;
  }
};

export const getEmailLoginSession = async (email: string, agentId?: string): Promise<EmailLoginSessionData> => {
  const res = await api.post<EmailLoginSessionResponse>('/prelogin/get_email_login_session', {
    email,
    agent_id: agentId
  })
  const validatedData = transformAndValidateEmailLoginSession(res.data);
  return validatedData;
}


